export enum Experiments {
  EXCLUDE_FULLDEAL_OFFERS = 'c81f3def-aee4-44fb',
}

export type AbTestingExperiments = Partial<Record<Experiments, boolean>>;

export const A_TEST_VALUE = '0';
export const B_TEST_VALUE = '1';
export const C_TEST_VALUE = '2';
export const D_TEST_VALUE = '3';
